var _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.10, written by Peter Selinger 2001-2011\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 408 l0 -71 -25 23 c-41 38 -42 13 -2 -28 l37 -37 37 37 c40 41 39 66 -2 28 l-25 -23 0 71 c0 41 -4 72 -10 72 -6 0 -10 -31 -10 -72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 342 c-46 -21 -98 -99 -76 -113 8 -5 20 -9 27 -9 8 0 12 -20 12 -64 l0 -64 101 -37 c99 -36 102 -37 142 -21 23 8 68 25 100 36 l57 21 0 65 c0 44 4 64 13 64 36 1 40 17 13 63 -20 33 -37 49 -69 61 -50 19 -57 19 -57 6 0 -5 11 -12 25 -16 14 -3 25 -9 25 -13 0 -3 -34 -18 -75 -33 l-75 -26 -75 26 c-41 15 -75 30 -75 33 0 4 11 10 25 13 14 4 25 11 25 16 0 14 -19 11 -63 -8z m141 -97 c2 -2 -4 -17 -13 -32 l-17 -29 -81 28 c-45 16 -83 31 -85 33 -2 2 4 17 13 33 l18 30 81 -30 c44 -16 82 -31 84 -33z m241 0 c-2 -2 -41 -17 -85 -33 l-81 -30 -18 30 c-9 16 -15 31 -13 32 1 2 39 17 83 33 l80 31 19 -30 c10 -16 17 -31 15 -33z m-267 -85 c4 0 14 12 22 28 15 26 15 23 16 -55 0 -46 -3 -83 -8 -83 -4 0 -41 13 -82 29 l-75 28 -3 51 -3 51 62 -25 c35 -13 66 -24 71 -24z m99 0 c5 0 37 11 70 25 l60 24 -3 -51 -3 -51 -75 -28 c-41 -16 -78 -29 -82 -29 -5 0 -8 37 -8 83 1 78 1 81 16 55 8 -16 19 -28 25 -28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackers);
export default __webpack_public_path__ + "static/media/packers.36b618d586cae2efd8dc786b564f8d8a.svg";
export { ForwardRef as ReactComponent };